import React, { Component } from "react";
import Chart from "react-apexcharts";

class PTGraph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chartOptions: {
        labels: [
          "Other",
          "New Store",
          "Remodel",
          "Conversion",
          "Refresh",
          "International",
          "SAA",
          "Relocation",
          "Conversion/Relocation",
          "Conversion/Remodel",
        ],

        colors: [
          "#CCC365",
          "#C4CA61",
          "#9FB84C",
          "#3B7171",
          "#0E6178",
          "#1F3A6D",
          "#211F68",
          "#553A7A",
          "#784488",
          "#934684",
        ],

        legend: {
          show: false,
        },

        tooltip: {
          enabled: true,
          inverseOrder: true,
          fillSeriesColor: false,
          marker: {
            show: false,
          },
        },

        dataLabels: {
          textAnchor: "middle",
          style: {
            fontSize: "9px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
          },
          background: {
            enabled: false,
            foreColor: "#fff",
            padding: 1,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: "#fff",
            opacity: 0.9,
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              color: "#000",
              opacity: 2,
            },
          },
          dropShadow: {
            enabled: true,
            top: 2,
            left: 2,
            blur: 2,
            color: "#000",
            opacity: 0.5,
          },

          formatter: function (value, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, value.toFixed(3) + "%"];
          },
        },

        plotOptions: {
          pie: {
            startAngle: 90,
            endAngle: 450,
            donut: {
              size: "43%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "11px",
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  offsetY: -3,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: "Project Type",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#373d3f",
                },
              },
            },
          },
        },
      },
      series: [9, 15, 20, 14, 10, 15, 15, 12, 30, 20],
    };
  }

  render() {
    return (
      <div className="donut">
        <Chart
          options={this.state.chartOptions}
          series={[
            this.props.data.Other,
            this.props.data.NewStore,
            this.props.data.Remodel,
            this.props.data.Conversion,
            this.props.data.Refresh,
            this.props.data.International,
            this.props.data.SAA,
            this.props.data.Relocation,
            this.props.data.ConversionRelocation,
            this.props.data.ConversionRemodel,
          ]}
          type="donut"
          height="280"
        />
      </div>
    );
  }
}

export default PTGraph;
